import './App.css';
import React from 'react';
import Header from './header';
import Content from './Content';
import Footer from './Footer';
import { Container } from './styles';





function App() {
  return (
    
    
    <div className='App'>
    

    
    <Container>
      

      <Header/>


      <body>
      
      <Content/>
      
      </body>
      <Footer/>

      
      
      
    </Container>
    </div>
    
    
  );
}

export default App;
